import { isEn } from "i18next-config";
import { camelToSnake, snakeToCamel } from "utils/camelSnakeTransformation";

export default class ChartSeriesDto {
  static fromApi(data) {
    return {
      ...DefaultSeriesProperties,
      key: snakeToCamel(data.key),
      isSelected: data.selected,
      isComparable: data.isComparable,
      labelLocales: data.label,
      label: isEn ? data.label.en : data.label.el,
      style: data.style,
      color: data.color,
      unit: data.unit,
      endpoint: data.type === "satellite" ? "satellite" : "weather",
      category: data.type,
      yAxisGroup: data.yAxisGroup,
    };
  }
  static fromApiArray(dataArray) {
    return dataArray.map(this.fromApi);
  }

  static toApi(key) {
    return {
      key: camelToSnake(key),
    };
  }
  static toApiArray(dataArray) {
    return dataArray.map(this.toApi);
  }
}

const DefaultSeriesProperties = {
  color: "#000000",
  // dashArray: null,
  // fillColor: "#000000",
  fillOpacity: 0.25,
  marker: true,
  // radius: 4,
  // strokeColor: "#000000",
  // strokeOpacity: 1,
  strokeWidth: 2,
  barSize: 8,
  tension: 0.2,
  // domain: ["auto", "auto"],
  // orientation: "left",
};
